import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {
  AppService,
  Cart,
  CartService,
  getCurrentDate,
  Host,
  Order,
  OrderMethod,
  PaymentType,
  relative_time
} from "../../../../../common";

@Component({
  selector: 'order-success',
  standalone: false,
  templateUrl: './order-success.html'
})

export class OrderSuccessPage implements OnInit {

  cart: Cart;
  host: Host;
  orderid: number;
  order: Order;

  constructor(
    private appService: AppService,
    private route: ActivatedRoute,
    private router: Router,
    private cartService: CartService
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.orderid = parseInt(params.get('orderid'));
      this.appService.load().subscribe(({host, cart}) => {
        this.host = host;
        this.cart = cart;
        this.order = this.cartService.getOrder(this.orderid);
      });
    })
  }

  hasEstimatedTime() {
    return this.order?.estimated_time;
  }

  isTakeout() {
    return this.order?.method == OrderMethod.takeout;
  }

  isDelivery() {
    return this.order?.method == OrderMethod.delivery;
  }

  getEstimatedTime() {
    const dt = getCurrentDate();
    dt.setTime(Date.parse(this.order.estimated_time));
    return relative_time(dt, this.host);
  }

  willGetEmail() {
    return this.order?.data?.address?.email && this.order?.method != OrderMethod.inhouse
  }

  showPaymentNotice() {
    return this.order?.method != OrderMethod.inhouse && this.order?.payment_type == PaymentType.OFFLINE;
  }

  showAlreadyPaidNotice() {
    return this.order?.payment_type == PaymentType.ONLINE;
  }

  canClose() {
    return this.appService.canClose();
  }

  onBtClose(event: MouseEvent) {
    event.preventDefault();
    this.appService.closeApp();
  }
}
